// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__5yZWk","searchRoot":"Search_searchRoot__4gZ46","searchBar":"Search_searchBar__AmG1J","searchIconWrapper":"Search_searchIconWrapper__10zLG"};